import { Dispatch } from "redux";
import { PriceModel } from "../../../models/Price.model";
import {
  PriceDispatchTypes,
  Price_SUCCESS,
  Price_FAILED,
  Price_LOADING,
} from "./PriceActionType";
var data: any = {};

export const GetPrice = (priceList: PriceModel[]) => async (
  dispatch: Dispatch<PriceDispatchTypes>
) => {
  try {
    dispatch({
      type: Price_LOADING,
    });
    priceList.map((price: PriceModel) => data[price.symbol] = price);

    dispatch({
      type: Price_SUCCESS,
      payload: {
        price: data,
      },
    });
  } catch (e) {
    dispatch({
      type: Price_FAILED,
    });
  }
};

// const getPrice = async (name: string) => {
//   const price = await fetchUrl({
//     url: `${apiUrl}live-data/history?symbol=${name}&limit=1`,
//     method: "GET",
//   });
//   if (price?.data.Data.Data[0]?.high) {
//     data[name] = price?.data.Data.Data[0]?.high;
//   } else {
//     data[name] = 1;
//   }
// };
